import Env from "../base/env";
import Channels from "../base/channels";
import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    this.funcLaunch = this._fx.bind(this);
    Channels.on("launcher::exit", this.funcLaunch);
    Channels.on("transition::end", this.funcLaunch);
  }

  _fx() {
    this.animate();
  }

  animate() {
    let offsetStart = Env.mobileCSS ? "top 90%" : "top 80%";
    this.animation = gsap.timeline({
      scrollTrigger: {
        trigger: this.DOM.view,
        start: offsetStart,
      },
    });

    this.animation.add([
      gsap.fromTo(
        this.ref.item,
        {
          autoAlpha: 0,
          scale: 1.1,
        },
        {
          autoAlpha: 1,
          scale: 1,
          ease: "cubic.out",
          duration: 0.6,
          stagger: 0.1,
        }
      ),
    ]);
  }

  unmount() {
    Channels.removeListener("launcher::exit", this.funcLaunch);
    Channels.removeListener("transition::end", this.funcLaunch);
  }
}
